<template>
    <div class="auth-layout-wrap">
        <!-- :style="{ backgroundImage: 'url(' + bgImage + ')' }" -->
        <div class="auth-content">
            <div class="card shadow-lg o-hidden">
                <div class="row">
                    <div class="col">
                        <div class="p-4">
                            <div class="text-center mb-4">
                                <img src="/static/img/logo/medium.png" />
                            </div>
                            <h1 class="mb-3 text-18">Esqueceu a senha?</h1>
                            <b-form @submit.prevent="submit">
                                <b-form-group label="Email">
                                    <b-form-input
                                        class="form-control form-control-rounded"
                                        label="Name"
                                        type="email"
                                        v-model.trim="email"
                                    >
                                    </b-form-input>
                                </b-form-group>
                                <b-button
                                    type="submit"
                                    block
                                    variant="primary"
                                    :disabled="
                                        submitStatus === 'PENDING' ||
                                        $v.$invalid
                                    "
                                    class="btn-rounded mt-3"
                                    >Resetar Senha</b-button
                                >
                            </b-form>
                            <div class="mt-3 text-center">
                                <router-link
                                    to="signin"
                                    tag="a"
                                    class="text-muted"
                                >
                                    <u>Fazer Login</u>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <!-- <div
                        class="col-md-6 text-center"
                        style="background-size: cover"
                    >
                        <div class="pr-3 auth-right">
                            <router-link
                                to="signup"
                                class="btn btn-outline-primary btn-outline-email btn-block btn-icon-text btn-rounded"
                            >
                                <i class="i-Mail-with-At-Sign"></i> Cadastrar-se
                            </router-link>
                            <a
                                class="btn btn-outline-primary btn-outline-google btn-block btn-icon-text btn-rounded"
                                @click="loginWithGoogle"
                            >
                                <i class="i-Google-Plus"></i> Login com Google
                            </a>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import { required, sameAs, minLength } from 'vuelidate/lib/validators'
// import { mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            email: '',
            submitStatus: null,
        }
    },

    validations: {
        // TODO Validação de e-mail aqui
    },

    computed: {
        // ...mapGetters(['loggedInUser', 'loading', 'error']),
    },

    methods: {
        // ...mapActions(['signUserUp']),
        //   validate form
        submit () {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
                return
            }

            this.submitStatus = 'PENDING'
            this.$store
                .dispatch('auth/resetPassword', { email: this.email })
                .then(() => {
                    this.email = ''
                    this.submitStatus = 'OK'
                    this.$router.push('/')
                })
                .catch(err => {
                    this.submitStatus = 'OK'
                    console.log('%c%s:%i', 'color: darkgreen', 'Forgot.vue', 122, err)
                })
        },
        loginWithGoogle () {
            this.$store
                .dispatch('auth/loginWithGoogle')
                .then(() => {
                    this.$router.push('/happiness/dashboard')
                })
                .catch(err => {
                    console.log('%c%s:%i', 'color: darkgreen', 'Signin.vue', 132, err)
                })
        },
        makeToast (variant = null) {
            this.$bvToast.toast('Successfully sent recovery email', {
                title: `Variant ${variant || 'default'}`,
                variant: variant,
                solid: true,
            })
        },
        inputSubmit () {
            console.log('submitted')
        },
    },
}
</script>
<style>
.spinner.sm {
    height: 2em;
    width: 2em;
}
</style>
